module.exports = __webpack_public_path__ + "img/logo-large.cb3849ff.svg";